import React, { useEffect, useState } from "react";
import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";
import {
  Checkbox,
  Input,
  Label,
  Select as RebassSelect,
} from "@rebass/forms/styled-components";
import { useUser } from "../../../../Hooks/useUser";

import { PartnerViewSession } from "../../../../State";
import { useRecoilState } from "recoil";

const domain = window.location.origin;

const StyledSelect = styled<any>(RebassSelect)`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  color: ${(props: any) => {
    return props.theme.colors.ice;
  }};
  width: 300px;
  outline: none;
  cursor: pointer;
  background-color: ${(props: any) => props.theme.colors.nedLight};
  border-color: transparent;
`;
export const TestViewer = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const clip = params.get("clip");
  const known = params.get("known");
  const { allstarUser } = useUser();
  const isAdmin = allstarUser?.isAdmin;
  const initialPlatform = params.get("platform");
  const [infoMesssage, setInfoMessage] = useState("" as any);
  const [partnerViewSession] = useRecoilState(PartnerViewSession);
  const [iframeState, setIframeState] = React.useState({
    partner: initialPlatform,
    known: known,
    width: "800px",
    height: "450px",
    useCase: params.get("useCase") || "POTG",
  });

  const [options, setOptions] = useState<string[]>([]);
  const [querystring, setQuerystring] = useState<string>("");
  const [steamId, setSteamId] = useState<string>(params.get("sid") || "");
  let partners = ["GC2022", "SCOPEGG2212", "L202211", "ESPORTAL23"];
  let resolutions = [
    { display: "600x338", width: "600px", height: "338px" },
    { display: "700x394", width: "700px", height: "394px" },
    {
      display: "800x450 (Recommended Minimum)",
      width: "800px",
      height: "450px",
    },
    { display: "900x506", width: "900px", height: "506px" },
    { display: "1000x563", width: "1000px", height: "562px" },
    { display: "1100x619", width: "1100px", height: "619px" },
    { display: "1200x675", width: "1200px", height: "675px" },
  ];

  const handleRes = (e: any) => {
    console.log(e.target.value);
    let res = resolutions.find((obj) => {
      return obj.display === e.target.value;
    });
    if (!res) return;

    setIframeState({ ...iframeState, width: res.width, height: res.height });
  };

  const handlePartner = (e: any) => {
    setIframeState({ ...iframeState, partner: e.target.value });
  };

  const handleUseCase = (e: any) => {
    setIframeState({ ...iframeState, useCase: e.target.value });
  };
  const handleKnown = (e: any) => {
    setIframeState({ ...iframeState, known: e.target.value });
  };
  const arrayToQuerystring = (array: string[]) => {
    let querystring = "";
    if (array.length === 0) return querystring;

    array.forEach((option) => {
      querystring += `&${option}=true`;
    });
    return querystring;
  };

  useEffect(() => {
    let string = arrayToQuerystring(options);
    setQuerystring(string);
  }, [options]);

  useEffect(() => {
    console.log("setting");
    setInfoMessage(
      getInfoMessage({
        iframeState,
        partnerViewSession,
        isAdmin,
        steamId,
        clip,
        querystring,
      })
    ); // eslint-disable-next-line
  }, [partnerViewSession.clip, iframeState, steamId, querystring]);

  return (
    <Fullscreen>
      <Left>
        {" "}
        <DropdownControls pb={5}>
          <DropdownFlex>
            {" "}
            <StyledBody>Resolution</StyledBody>
            <StyledSelect
              variant="small"
              onChange={handleRes}
              defaultValue={"800x450 (Recommended Minimum)"}
            >
              {resolutions.map((resolution: any) => {
                return (
                  <>
                    {" "}
                    <option value={resolution.display}>
                      {resolution.display}
                    </option>
                  </>
                );
              })}
            </StyledSelect>
          </DropdownFlex>
          <DropdownFlex>
            {" "}
            <StyledBody>Viewer Steam ID (required)</StyledBody>
            <StyledInput
              variant="default"
              value={steamId}
              defaultValue={steamId}
              onChange={(e) => {
                setSteamId(e.target.value);
              }}
            />
          </DropdownFlex>
          {isAdmin && (
            <>
              {" "}
              <DropdownFlex>
                {" "}
                <StyledBody>Partner</StyledBody>
                <StyledSelect
                  variant="small"
                  onChange={handlePartner}
                  defaultValue={iframeState.partner}
                >
                  {partners.map((partner: string) => {
                    return (
                      <>
                        {" "}
                        <option value={partner}>{partner}</option>
                      </>
                    );
                  })}
                </StyledSelect>
              </DropdownFlex>
            </>
          )}
          {isAdmin && (
            <>
              {" "}
              <DropdownFlex>
                {" "}
                <StyledBody>Use Case</StyledBody>
                <StyledSelect
                  variant="small"
                  onChange={handleUseCase}
                  defaultValue={iframeState.useCase}
                >
                  {["PMH", "WC", "POTG"].map((usecase: string) => {
                    return (
                      <>
                        {" "}
                        <option value={usecase}>{usecase}</option>
                      </>
                    );
                  })}
                </StyledSelect>
              </DropdownFlex>
            </>
          )}
          {isAdmin && (
            <>
              {" "}
              <DropdownFlex>
                {" "}
                <StyledBody>Known User?</StyledBody>
                <StyledSelect
                  variant="small"
                  onChange={handleKnown}
                  defaultValue={iframeState.known}
                >
                  {" "}
                  <option value={"true"}>true</option>
                  <option value={"false"}>false</option>
                </StyledSelect>
              </DropdownFlex>
            </>
          )}
          {/* {isAdmin && (
            <>
              {" "}
              <DropdownFlex>
                {" "}
                <StyledBody>Resolution Config</StyledBody>
                <StyledSelect
                  variant="small"
                  onChange={(e: any) => {
                    setResolutionConfig(e.target.value);
                  }}
                  defaultValue={"0"}
                >
                  {" "}
                  <option value={"1"}>720P30</option>
                  <option value={"2"}>1080P60</option>
                </StyledSelect>
              </DropdownFlex>
            </>
          )} */}
        </DropdownControls>
        <OptionChecks mb={5}>
          <Box>
            {" "}
            <Label>
              {" "}
              <Checkbox
                mr={2}
                onChange={(e) => {
                  if (e.target.checked) {
                    setOptions([...options, "background"]);
                  } else {
                    setOptions(
                      options.filter((option) => option !== "background")
                    );
                  }
                }}
              />
              Background
            </Label>
          </Box>
          <Box>
            {" "}
            <Label>
              {" "}
              <Checkbox
                mr={2}
                onChange={(e) => {
                  if (e.target.checked) {
                    setOptions([...options, "fullscreen"]);
                  } else {
                    setOptions(
                      options.filter((option) => option !== "fullscreen")
                    );
                  }
                }}
              />
              Fullscreen
            </Label>
          </Box>
          <Box>
            {" "}
            <Label>
              {" "}
              <Checkbox
                mr={2}
                onChange={(e) => {
                  if (e.target.checked) {
                    setOptions([...options, "loop"]);
                  } else {
                    setOptions(options.filter((option) => option !== "loop"));
                  }
                }}
              />
              Loop
            </Label>
          </Box>
          <Box>
            {" "}
            <Label>
              {" "}
              <Checkbox
                mr={2}
                onChange={(e) => {
                  if (e.target.checked) {
                    setOptions([...options, "autoplay"]);
                  } else {
                    setOptions(
                      options.filter((option) => option !== "autoplay")
                    );
                  }
                }}
              />
              Autoplay
            </Label>
          </Box>
        </OptionChecks>
      </Left>
      <Right>
        {" "}
        <iframe
          title={"test-allstar-iframe"}
          allowFullScreen
          src={`${domain}/iframe?clip=${clip}&platform=${iframeState.partner}&sid=${steamId}&known=${iframeState.known}${querystring}&useCase=${iframeState.useCase}`}
          width={iframeState.width}
          height={iframeState.height}
        />
        <Flex pt={4}>{infoMesssage}</Flex>
      </Right>
    </Fullscreen>
  );
};
const getInfoMessage = ({
  iframeState,
  partnerViewSession,
  isAdmin,
  steamId,
  clip,
  querystring,
}: any) => {
  const knownDueToQuery = iframeState.known === "true";
  const knownDueToToken = Boolean(localStorage.getItem("token"));
  const ownsClipDueToUseCase = ["PMH", "WC"].includes(iframeState.useCase);
  const ownsClipDueToSteamIdMatch =
    steamId === partnerViewSession?.clip?.steamId64;
  if (isAdmin) {
    return (
      <Flex flexDirection={"column"} style={{ gap: "10px" }}>
        <Box>
          {`ADMIN MODE, YOUR IFRAME SOURCE ${domain}/iframe?clip=${clip}&platform=${iframeState.partner}&sid=${steamId}&known=${iframeState.known}${querystring}&useCase=${iframeState.useCase}`}
        </Box>
        {knownDueToQuery && (
          <Box>This is a known user determined by query string </Box>
        )}
        {knownDueToToken && (
          <Box>
            {" "}
            This is a known user determined by existence of their token
          </Box>
        )}
        {ownsClipDueToUseCase && (
          <Box>The viewer owns this clip determined by use case</Box>
        )}
        {ownsClipDueToSteamIdMatch && (
          <Box>
            The viewer owns this clip determined by steamId query parameter
            matching the clip
          </Box>
        )}
      </Flex>
    );
  } else {
    return `QUERY STRING TO APPEND TO YOUR IFRAME SOURCE: ${querystring}&sid={VIEWER_STEAM_ID}`;
  }
};

const Left = styled(Flex)`
  flex-direction: column;
`;
const Right = styled(Flex)`
  flex-direction: column;
  align-items: center;
`;
const OptionChecks = styled(Flex)`
  margin-top: 20px;
  gap: 10px;
  justify-content: space-around;
  flex-direction: column;
  width: 100%;
`;

const StyledInput = styled(Input)`
  font-size: 2;
  px: 5;
  line-height: "3.125rem";
  height: "3.125rem";
`;

const Fullscreen = styled(Flex)`
  justify-content: center;
  padding: 50px;
  gap: 100px;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

const DropdownControls = styled(Flex)`
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  gap: 10px;
`;

const StyledBody = styled(Box)`
  font-size: 20px;
  padding-bottom: 15px;
`;

const DropdownFlex = styled(Flex)`
  flex-direction: column;
`;
